/**
 * Keyword Loading State Manager
 * 
 * Handles loading state UI for keyword operations.
 * Shows/hides loading indicators and disables inputs during async operations.
 */

/**
 * Shows loading state for the keyword add form
 * @param {Object} elements - Object containing DOM elements
 * @param {HTMLElement} elements.buttons - The add keyword buttons
 * @param {HTMLElement} elements.message - The "adding keyword" message element
 * @param {HTMLElement} elements.loadingIcon - The loading spinner element
 * @param {HTMLElement} elements.productSelect - The product select dropdown
 */
export function showAddKeywordLoading(elements) {
  const { buttons, message, loadingIcon, productSelect } = elements

  if (buttons) {
    buttons.forEach(btn => {
      btn.classList.add('d-none')
      btn.classList.remove('d-inline-block')
    })
  }
  if (message) {
    message.classList.remove('d-none')
    message.classList.add('d-inline')
  }
  if (loadingIcon) {
    loadingIcon.classList.remove('d-none')
    loadingIcon.classList.add('d-inline')
  }
  if (productSelect) productSelect.disabled = true
}

/**
 * Hides loading state for the keyword add form
 * @param {Object} elements - Object containing DOM elements
 */
export function hideAddKeywordLoading(elements) {
  const { buttons, message, loadingIcon, productSelect } = elements

  if (buttons) {
    buttons.forEach(btn => {
      btn.classList.remove('d-none')
      btn.classList.add('d-inline-block')
    })
  }
  if (message) {
    message.classList.add('d-none')
    message.classList.remove('d-inline')
  }
  if (loadingIcon) {
    loadingIcon.classList.add('d-none')
    loadingIcon.classList.remove('d-inline')
  }
  if (productSelect) productSelect.disabled = false
}

/**
 * Shows loading state when switching products in the dropdown
 * @param {Object} elements - Object containing DOM elements
 * @param {HTMLElement} elements.title - The keyword title element
 * @param {HTMLElement} elements.loadingIcon - The loading spinner element
 * @param {HTMLElement} elements.list - The keyword list element
 */
export function showProductSwitchLoading(elements) {
  const { title, loadingIcon, list } = elements

  if (title) title.textContent = 'Loading'
  if (loadingIcon) {
    loadingIcon.classList.remove('d-none')
    loadingIcon.classList.add('d-block')
  }
  if (list) {
    list.innerHTML = ''
    list.textContent = 'Loading...'
    list.classList.add('p-2', 'ps-3')
  }
}

/**
 * Hides loading state when product switch is complete
 * @param {Object} elements - Object containing DOM elements
 */
export function hideProductSwitchLoading(elements) {
  const { loadingIcon, list } = elements

  if (loadingIcon) {
    loadingIcon.classList.add('d-none')
    loadingIcon.classList.remove('d-block')
  }
  if (list) {
    list.classList.remove('p-2', 'ps-3')
  }
}
